/*
--- 
description: FED Process
authors: 
- Anton Burov
license:
- MIT-style license
requires: 
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [BasicMaps]
...
*/
var BasicMapsHoods = new Class({
	Extends: AmenitiesMap,
	
	defer_build: function()
	{
		this.main_remote = null;
		this.map = new google.maps.Map(this._map, 
		{
			 zoom: 12,
			 center: new google.maps.LatLng(40.7646, -73.9777),
			 mapTypeId: google.maps.MapTypeId.ROADMAP,
			 streetViewControl: false,
			 scrollwheel: false
		});

		if(this.options.styled){
			this.map.setOptions({styles: this.options.map_styles});
		}

		this._veil = this._element.getElement('.'+this.options.cls+'_veil');

		(function(){
			this.update_map()
		}.bind(this)).delay(700);
	},
	
	update_map: function() {
		var bounds = this.map.getBounds();
		this._veil.setStyle('opacity', '0.8');
		this._veil.setStyle('display', 'block');

		if(this.options.rpc)
		{
			if (this.main_remote) {
				this.main_remote.options.data = '&bounds='+bounds.toUrlValue();
				this.main_remote.prepare().send();
				return;
			}
			this.main_remote = new Remote
			({
				rpc: this.options.rpc,
				data: '&bounds='+bounds.toUrlValue(),
				rpc_path: '',
				onSuccess: this.process_rpc.bind(this)
			});
		}
	} 
});